let imageWindow = null;

/**
 * saveImageFromUrl - Guarda una imagen desde una URL utilizando la mejor estrategia disponible
 * @param {string} imageUrl - URL de la imagen a guardar
 * @param {Object} options - Opciones adicionales
 * @returns {Promise<void>}
 */
export async function saveImageFromUrl(
    imageUrl,
    { fileName = "imagen.jpg", shareTitle = "", iosHelperText = "" } = {}
) {
    const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    // Abrir la ventana solo una vez (antes de await)
    if (isIOS) {
        imageWindow = window.open("", "_blank");

        // Crear el visor UNA SOLA VEZ
        imageWindow.document.body.innerHTML = `
      <div style="
        background:black;
        height:100vh;
        display:flex;
        align-items:center;
        justify-content:center;
      ">
        <img id="ios-image-viewer"
          style="max-width:100%;max-height:100%;object-fit:contain;" />

        <div style="
          position:fixed;
          bottom:20px;
          left:20px;
          right:20px;
          background:rgba(0,0,0,0.8);
          color:white;
          padding:12px;
          border-radius:12px;
          text-align:center;
          font-size:3rem;
          font-family:system-ui;
        ">
          ${iosHelperText}
        </div>
      </div>
    `;
    }

    // Intentar Web Share API
    try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const file = new File([blob], fileName, { type: blob.type });

        if (navigator.canShare && navigator.canShare({ files: [file] })) {
            await navigator.share({
                files: [file],
                title: shareTitle,
            });
            return;
        }
    } catch (err) {}

    // Fallback iOS: SOLO cambiar la imagen
    if (isIOS && imageWindow && !imageWindow.closed) {
        const img = imageWindow.document.getElementById("ios-image-viewer");
        if (img) {
            img.src = imageUrl;
        }
        return;
    }

    // Desktop: descarga directa
    const a = document.createElement("a");
    a.href = imageUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}